<template>
    <div class="product-benefits">
      <slot></slot>
    </div>
</template>

<style>
  product-benefits {
    color: #52d3aa; 
  }
</style>

<script>
  import ProductBenefit from './productBenefit.vue'

  export default {
    name: 'ProductBenefits',
    components: {
      ProductBenefit
    }
  }
</script>
